import * as S from './styles';
import VisaLogo from '../../../assets/images/visa.svg'

declare type CreditCardProps = {
    title?: string;
    cardLabel?: string;
    theme?: string;
    buttonColor?: string;
}

export default function CreditCard({ title, cardLabel, theme, buttonColor }: CreditCardProps) {
    const resolvedTheme = theme || buttonColor;

    return (
        <S.Container>
            <S.CreditCardContainer $theme={resolvedTheme}>
                <S.Header>
                    <S.CardTitle>{cardLabel ?? 'Crédito'}</S.CardTitle>
                    <S.BrandIcon src={VisaLogo} alt="Visa" />
                </S.Header>

                <S.NumberRow>
                    <S.MaskedNumber>* * * *  * * * *  * * * *  * * * * </S.MaskedNumber>
                </S.NumberRow>

                <S.HolderName>{title}</S.HolderName>
            </S.CreditCardContainer>
        </S.Container>
    )
}